import React, { useState } from "react";
import "./Testimonials.css";
import { testimonialsData } from "../../data/testimonialsData";
import leftArrow from "../../assets/leftArrow.png";
import rightArrow from "../../assets/rightArrow.png";
import { motion } from "framer-motion";

const Testimonials = () => {
  const transition = { type: "spring", duration: "3" };
  const [selected, setSelected] = useState(0);
  //   Initializes useState with (0), 1st element of array
  //   Don't forget to import {useState} in component
  const tLength = testimonialsData.length;
  return (
    <div className="testimonials" id="testimonialid">
      <div className="left-t">
        {/* below span is nth of child(1) for class (left-t) */}
        <span>Testimonials</span>
        {/* below span is nth of child(2) for class (left-t) */}
        <span className="stroke-text">What they</span>
        {/* below span is nth of child(3) for class (left-t) */}
        <span>say about us</span>
        {/* below span nth of child(4) for class (left-t) */}
        <motion.span
          key={selected}
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 100 }}
          transition={transition}
        >
          {testimonialsData[selected].review}
        </motion.span>
        {/* below span is nth of child(5) for class (left-t) */}
        <span>
          <span style={{ color: "var(--orange)" }}>
            {testimonialsData[selected].name}
          </span>{" "}
          - {testimonialsData[selected].status}
          {/* Entered string using {" "} */}
        </span>
      </div>
      <div className="right-t">
        {/* div for cards behind image for design */}
        {/* below div for bordered card */}
        <motion.div
          initial={{ opacity: "0", x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ ...transition, duration: 2 }}
        ></motion.div>
        {/* below div for filled card */}
        <motion.div
          initial={{ opacity: "0", x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ ...transition, duration: 2 }}
        ></motion.div>
        {/* dynamcic image changing using useState */}
        <motion.img
          key={selected}
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -100 }}
          transition={transition}
          src={testimonialsData[selected].image}
          alt=""
        />

        <div className="arrows">
          <img
            onClick={() => {
              selected === 0
                ? setSelected(tLength - 1)
                : setSelected((prev) => prev - 1);
            }}
            src={leftArrow}
            alt=""
          />
          <img
            onClick={() => {
              selected === tLength - 1
                ? setSelected(0)
                : setSelected((prev) => prev + 1);
            }}
            src={rightArrow}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
